/// <amd-module name="Artifacts/Root/helpers/CollectionHelpers" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPageService } from "VSS/Platform/Page";

export function getCurrentCollectionName(pageContext: IVssPageContext): string {
  const pageService = pageContext.getService<IVssPageService>("IVssPageService");
  const pageData = pageService.getData();

  return pageData ? pageData.hostName : "";
}

export function getCurrentCollectionId(pageContext: IVssPageContext): string {
  const pageService = pageContext.getService<IVssPageService>("IVssPageService");
  const pageData = pageService.getData();

  return pageData ? pageData.hostId : "";
}

export function getIsHosted(pageContext: IVssPageContext): boolean {
  const pageService = pageContext.getService<IVssPageService>("IVssPageService");
  const pageData = pageService.getData();

  // Should we default to true?
  return pageData ? pageData.isHosted : true;
}
